import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  summaryTable: {
    borderSpacing: '0 24px',
    // borderCollapse: 'collapse',
    verticalAlign: 'text-top',
    '& td': {
      // height: '42px', // works like minHeight
      verticalAlign: 'text-top',
    },
  },
}));

export default useStyles;
